import React from 'react';
import * as Header from '@/components/atoms/Header';
import styles from './Tabs.module.scss';

const View: React.FC<{
  tabs: { label: string; active: boolean; onClick: () => void; key: string }[];
}> = ({ tabs }) => {
  return (
    <div className={styles.container}>
      {tabs.map(({ label, active, onClick, key }) => {
        return (
          <Header.Tab
            key={label}
            label={label}
            active={active}
            onClick={onClick}
            id={key}
          />
        );
      })}
    </div>
  );
};

export default View;
